<template>
  <div class='reportList font14'>
    <div class="top font18 flex-between" v-if="curRole==3">
        <p><b>班级报告</b></p>
        <van-dropdown-menu v-if="classList.length>0">
          <van-dropdown-item v-model="classId" :options="classList" @change='selectClass' />
        </van-dropdown-menu>
        <span v-else>--班</span>
    </div>
    <template v-else>
      <switch-role @changes='getList'></switch-role>
    </template>
    <div class="reportCon">
        <div class="top_class">
          <img src="@/assets/img/step/report_banner.jpg" alt="" @click='gotoUrl("ropeSkipping")' v-if="isBanner=='true'">
          <img src="@/assets/img/step/report_bgc.png" alt="" v-else>
        </div>
        <!--手环-->
        <div class="stepCon" v-if="curRole==5&&list.smartBand" @click="gotoUrl('braceletDetail')">
            <div class='title font18 flex-between'><p>健康运动<span class='font10 gray'>（来自华为手环）</span></p><p class="gray font12">更多 <van-icon name="arrow" /></p></div>
            <div class="flex-between">
                <div class="con wid">
                    <p class='gray font14 flex'><img src='@/assets/img/step/motion1.png' class="img2"><span>心率</span></p>
                    <p class="gray font14">
                        <template v-if='list.smartBand.heartRate'><span class="curStep">{{list.smartBand.heartRate}}</span> 次/分钟</template>
                        <template v-else><span class="curStep">--</span></template>
                    </p>
                </div>
                <div class="con wid">
                    <p class='gray font14 flex'><img src='@/assets/img/step/motion2.png' class="img2"><span>热量消耗</span></p>
                    <p class="gray font14">
                        <template v-if='list.smartBand.calorie'><span class="curStep">{{list.smartBand.calorie}}</span> 千卡</template>
                        <template v-else><span class="curStep">--</span></template>
                    </p>
                </div>
            </div>
        </div>
        <!--步数-->
        <div class="stepCon" v-if="curRole==5&&list.stepStat" @click="gotoUrl('stepDetail',{type:2,classId:classId})">
            <div class='title font18 flex-between'><p>运动步数<span class='font10 gray'>（来自在鸿学生终端）</span></p><p class="gray font12">更多 <van-icon name="arrow" /></p></div>
            <div class="con">
                <div class="flex-between">
                  <p class="font14 gray"><span class='curStep'>{{list.stepStat.stepNum}}</span> 步/{{list.stepStat.targetStep}}步</p>
                  <svg-icon icon-class="foot"  />
                </div>
                <div class="stepLine gray">
                  <span class="point">0</span>
                  <span class='point totalPoint'>{{list.stepStat.targetStep}}</span>
                  <van-progress :percentage="percentage" :show-pivot='false' />
                </div>
            </div>
        </div>
        <!--跳绳-->
        <div class="stepCon"  v-if="list.skipStat||(list.skipReport&&classList.length>0)"  @click="gotoUrl('reportDetail',{type:1,classId:classId})">
            <div class='title font18 flex-between'><p>智慧跳绳<span class='font10 gray'>（来自智慧跳绳）</span></p><p class="gray font12">更多 <van-icon name="arrow" /></p></div>
            <div class="list">
                <div class='tit' v-if="curRole==3">
                    <p class="border"><span class='color'>{{list.skipReport.todayNum}}</span><br><span class='gray'>今日总数(个)</span></p>
                    <p class="border"><span class='color'>{{list.skipReport.weekNum}}</span><br><span class='gray'>本周总数(个)</span></p>
                    <p><span class='color'>{{list.skipReport.monthNum}}</span><br><span class='gray'>本月总数(个)</span></p>
                </div>
                <template  v-else>
                    <div class='new_tit' style="padding-bottom: 0;">
                          <div class="tit_con">
                            <div><img src="@/assets/img/step/zre2.png" alt=""></div>
                            <div><span class='color'>今日个数</span><br><span class='black_weight'>{{list.skipStat.skipNums==0?"--":list.skipStat.skipNums}}</span><span class="font14 gray" v-if="list.skipStat.skipNums>0">个</span></div>
                          </div>
                          <div class="tit_con" >
                            <div><img src="@/assets/img/step/zre1.png" alt=""></div>
                            <div><span class='color'>训练</span><br><span class='black_weight'>{{list.skipStat.num==0?"--":list.skipStat.num}}</span><span class="font14 gray" v-if="list.skipStat.num">次</span></div>
                          </div>
                    </div>
                    <div class='new_tit' style="padding-top: 0.4rem;">
                          <div  class="tit_con">
                            <div><img src="@/assets/img/step/zre3.png" alt=""></div>
                            <div><span class='color'>时长</span><br><span class='black_weight'>{{list.skipStat.skipTimes==0?"--":list.skipStat.skipTimes}}</span><span class="font14 gray" v-if="list.skipStat.skipTimes>0">分</span></div>
                          </div>
                          <div  class="tit_con">
                            <div><img src="@/assets/img/step/zre4.png" alt=""></div>
                            <div><span class='color'>速率(分钟)</span><br><span class='black_weight'>{{list.skipStat.skipAvgNums==0?"--":list.skipStat.skipAvgNums}}</span><span class="font14 gray" v-if='list.skipStat.skipAvgNums>0'>个</span></div>
                          </div>
                    </div>
                </template>
            </div>
        </div>
        <!--课堂互动-->
        <div class="stepCon"  v-if="list.classInteraction||(list.classInteraction&&classList.length>0)"  @click="gotoUrl('reportDetail',{type:3,classId:classId})">
            <div class='title font18 flex-between'><p>课堂互动<span class='font10 gray'>（来自鸿蒙课堂）</span></p><p class="gray font12">更多 <van-icon name="arrow" /></p></div>
            <div class="list">
                <div class='tit' v-if="curRole==3">
                  <p class="border"><span class='color'>{{list.classInteraction.studentNum}}</span><br><span class='gray'>{{list.classInteraction.subjectName}}参与学生(个)</span></p>
                  <p><span class='color'>{{list.classInteraction.accuracy}}</span>%<br><span class='gray'>{{list.classInteraction.subjectName}}平均正确率</span></p>
                </div>
                <div class='tit' v-else>
                      <p class="border"><span class='color'>{{list.classInteraction.questionNum}}</span>个<br><span class='gray'>{{list.classInteraction.subjectName}}答题数</span></p>
                      <p class="border"><span class='color'>{{list.classInteraction.correctNum}}</span><br><span class='gray'>{{list.classInteraction.subjectName}}正确</span></p>
                      <p><span class='color'>{{list.classInteraction.accuracy}}</span>%<br><span class='gray'>{{list.classInteraction.subjectName}}正确率</span></p>
                </div>
            </div>
        </div>
        <!--打卡-->
        <div class="stepCon"  v-if="list.beaconStat||(list.beaconReport&&classList.length>0)" @click="gotoUrl('reportDetail',{type:2,classId:classId})">
            <div class='title font18 flex-between' ><p>实践打卡<span class='font10 gray'>（来自在鸿学生终端）</span></p><p class="gray font12" >更多 <van-icon name="arrow" /></p></div>
            <div class="list">
            <div class='tit' v-if="curRole==3">
              <p class="border"><span class='color'>{{list.beaconReport.weekNum}}</span><br><span class='gray'>本周打卡(人次)</span></p>
              <p class="border"><span class='color'>{{list.beaconReport.monthNum}}</span><br><span class='gray'>本月打卡(人次)</span></p>
              <p><span class='color'>{{list.beaconReport.termNum}}</span><br><span class='gray'>本学期打卡(人次)</span></p>
            </div>
            <div class='tit' v-else>
                  <p class="border"><span class='color'>{{list.beaconStat.beaconWeekNums}}</span><br><span class='gray'>本周打卡(次)</span></p>
                  <p class="border"><span class='color'>{{list.beaconStat.beaconMonthNums}}</span><br><span class='gray'>本月打卡(次)</span></p>
                  <p><span class='color'>{{list.beaconStat.beaconTermNums}}</span><br><span class='gray'>总打卡(次)</span></p>
            </div>
        </div>
        </div>
    </div>
  
     <div class='noData' v-if="text&&classList.length==0"><div><img :src='require("@/assets/img/nodata.png")'><br />{{text}}</div></div>
  
  </div>
</template>
<script>
import switchRole from "./components/switchRole.vue";
import {stat,getReport} from "@/api/api.report";
import {getTeachingInfo} from '@/api/api.mine.js';
  export default {
    data() {
      return {
        list:'',
        curRole:this.$store.state.loginUser.currentUserType,//3老师，5家长
        classList:[],
        classId:'',
        text:'',
        percentage:'',
        isBanner:newBanner,
      }
    },
   components:{switchRole},
   created(){
     if(this.curRole==5){
       this.getList();
     }else{
       this.getClass();
     }
     sessionStorage.removeItem('details');
     sessionStorage.removeItem('classes');
     sessionStorage.removeItem('type');
    },
    methods: {
      getClass(){
        getTeachingInfo({teacherId:this.loginUser.teacherId}).then(data=>{
           if(data.result.length>0){
                data.result.forEach(item=>{
                  item.text=item.className;
                  item.value=item.classId;
                })
              
                this.classList=data.result;
                if(sessionStorage.classes){
                  let curClass=JSON.parse(sessionStorage.classes);
                  this.classId=curClass.classId;
                }else{
                  this.classId=data.result[0].classId;
                  sessionStorage.setItem('classes',JSON.stringify(data.result[0]));
                }
                this.getList();
            }else{
                 this.text='暂无数据'
            }
        })
      },
      selectClass(val){
        let arr=this.classList.filter(item=>item.classId==val);
        sessionStorage.setItem('classes',JSON.stringify(arr[0]));
        this.getList(); 
      },
       getList(){
         if(this.curRole==3){
           getReport({
              classId:this.classId,
              teacherId:this.loginUser.teacherId,
           }).then((data) => {
            if (data && data.result) {
                  this.list=data.result;
            }
           })
         }else{
           stat({
              studentId:this.loginUser.studentId
           }).then((data) => {
            if (data && data.result) {
          //   data.result.smartBand={heartRate:145,calorie:22};
                  this.list=data.result;
                
                  if(data.result.stepStat){
                     this.percentage=(data.result.stepStat.stepNum/data.result.stepStat.targetStep)*100;
                     this.percentage=parseFloat(this.percentage)>100?100:this.percentage;
                  }
                  if(data.result.smartBand){
                    data.result.smartBand.calorie=data.result.smartBand.calorie?Math.round(data.result.smartBand.calorie / 1000):'';
                  }
            }else{
              this.text='暂无数据'
            }
           })
         }
         
       },
    
    },
  }
</script>
<style lang="scss" >
.reportList{
  padding:0rem 0rem .7rem;
  color:rgba(0,0,0,.9);
  .font10{
    font-size: .1rem;
  }
  .font20{
    font-size: .2rem;
  }
  .reportCon{
     padding:.12rem;
  }
  .top_class{
    img{
      width: 100%;
      border-radius:8px;
    }
  }
  .top{
    padding:.12rem .12rem 0rem;
    
  }
  .van-dropdown-menu{
    .van-dropdown-menu__bar{
      box-shadow: none;
      background:transparent;
    }
    .van-dropdown-menu__title::after{
      border-color:transparent transparent #7f7f7f #7f7f7f;
    }
    .van-dropdown-menu__title--active::after{
      border-color:transparent transparent currentColor currentColor;
    }
    .van-dropdown-menu__title{
      font-size: .15rem;
      line-height: .25rem;
    }
  }
  .list{
    border-radius:8px;
    background: #fff;
    padding: .2rem 0;
    color:#798190;
    .tit{
      display: flex;
      justify-content: center;
      text-align: center;
      color:#162746;
      p{
        flex: 1;
        position: relative;
        
        .color{
          margin-right: 5px;
          margin-bottom: .04rem;
          display: inline-block;
          font-size: .24rem;
        }
        &.border::after{
          content: '';
          width: 1px;
          height: 50%;
          display: inline-block;
          position: absolute;
          background:rgba(0,0,0,.2);
          top: 30%;
          right: 0px;
        }
      }
    }
    .new_tit{
      display: flex;
      justify-content: space-between;
      padding: 0.25rem;
      img{
          width: 0.4rem;
          height: 0.4rem;
          margin-right: 0.12rem;
      }
      .tit_con{
        display: flex;
        flex: 1;
        align-items: center;
        
      }
      .black_weight{
          font-size: 0.2rem;
          font-weight: 500;
          color: rgba(0,0,0,0.86);
      }
    }
  }
 
  .stepCon{
    margin-top:.22rem;
     .title{
       padding: 0 .12rem;
       margin-bottom: .12rem;
       .van-icon{
         color: #000;
       }
     }
     .con{
       background:#fff;
       border-radius:8px;
       padding:.12rem .12rem .3rem;
       overflow: hidden;
       .curStep{
         color:#000;
        //  font-weight: bold;
         font-size: .24rem;
       }
       .stepLine{
         margin-top: .1rem;
         position: relative;
         .point{
           position: absolute;
           margin-top: .08rem;
         }
         .curPoint{
           margin-left: -.1rem;
         }     
         .totalPoint{
           right: 0;
         }
       }
     }
     .wid{
      flex: 1;
      padding-bottom: .16rem;
      .img2{
        width:.18rem;
        height: .18rem;
        margin-right: .04rem;
       }
      .flex{
        display: flex;
        margin-bottom: .13rem;
      }
      &:first-child{
        margin-right: .12rem;
      }
     }
  }
}

</style>